import React from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import i18n from '../../../i18n/i18n';
import Select from 'react-select';
import { Fab, Button } from '@material-ui/core';
import { wentWrong } from "../../../utils/ToastConfig";
import axios from '../../../utils/AxiosWrapper';
import checkboxHOC from "react-table/lib/hoc/selectTable";
import SearchBar from 'material-ui-search-bar';
import moment from 'moment';

//const styles = theme => ({ primaryMain: { backgroundColor: theme.palette.primary.main } });
//const CheckboxTable = checkboxHOC(ReactTable);;

const commonHeaderStyle = {
    textAlign: 'center',
    textTransform: 'uppercase',
    paddingTop: 10,
    paddingBottom: 10,
    backgroundColor: '#04764e',
    color: "#ffff",

};

const searchWrapStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '20px 30px 20px 30px'
};

const searchBarStyle = {
    width: '40%',
    height: '40px',
    border: '1px solid #979797',
    maxWidth: '421px'
};

export default class ArchiveList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showFilters: false, loading: false,
            page: 0, pageSize: 10, sorted: null, filtered: null,
            selection: [], selectAll: false, selectedRow: [],
            totalPages: 0,
            searchBarValue: '',
            add: false, edit: false, delete: false,
            data: [], alert: false
        };
        this.toggleSelection = this.toggleSelection.bind(this);
    }

    componentDidMount() {
        //this.getByURL('workplace/drop_down', 'workplaceType');
        // this.getByURL('worker/filter_worker_group', 'groupType');
        //this.getByURL('worker/filter_sector', 'sectorType');
        this.setState({ loading: false }, () => {
            this.reactTable.fireFetchData();
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.searchBarValue !== this.state.searchBarValue) {
            this.setState({
                load: true
            })
            this.reactTable.fireFetchData();
        }
    }

    getData(url, state, instance) {
        this.setState({ loading: true, data: [] });

        let filtered = [...state.filtered];
        if (this.state.searchBarValue) {
            filtered.push({ id: 'naziv', value: this.state.searchBarValue });
        }

        axios.get(`api/${url}`, {
            params: { page: state.page, pageSize: state.pageSize, sorted: state.sorted, filtered: filtered }
        })
            .then(res => {
                this.setState({
                    data: res.data.data,
                    totalPages: res.data.total_pages,
                    loading: false
                });
            })
            .catch(error => {
                wentWrong('Something went wrong, please try again!');
                console.log('Error 1 (getData): ', error);
            })
    }

    getByURL(url, obj) {
        axios.get(`api/${url}`)
            .then(res => this.setState({ [obj]: res.data.data }))
            .catch(error => {
                wentWrong('Something went wrong, please try again!');
                console.log('Error 2 (getByURL): ', error, ', URL: ', url);
            })
    }

    toggleAll = () => {
        const selectAll = this.state.selectAll ? false : true, selection = [];
        if (selectAll) {
            const wrappedInstance = this.checkboxTable.getWrappedInstance();
            const currentRecords = wrappedInstance.getResolvedState().sortedData;
            currentRecords.forEach(item => { selection.push(item._original.id); });
        }
        this.setState({ selectAll, selection });
    };

    toggleSelection = (key, shift, row) => {
        let selection = [...this.state.selection], selectedRow = null;
        const keyIndex = selection.indexOf(key);
        if (keyIndex >= 0) selection = [...selection.slice(0, keyIndex), ...selection.slice(keyIndex + 1)];
        else selection.push(key);
        if (selection.length == 1) selectedRow = this.state.data.filter((el) => el.id == selection)[0];
        this.setState({ selection, selectedRow });
    };

    handleClick = () => {
        if (this.state.edit == true && this.state.add == false) this.setState({ edit: false, selectedRow: [] });
        else if (this.state.selection.length > 0 && this.state.add == false && this.state.edit == false) this.setState({ selectedRow: [] });
        this.setState({ add: !this.state.add }, () => {
            if (this.state.add === false) this.getData('field/read_parts', this.state);
            if (this.state.add == true && this.state.edit == false) this.setState({ selection: [], selectAll: false, });
        });
    };

    handleSearchBar = (searchVal) => {
        this.setState({
            searchBarValue: searchVal
        }, () => {
            if (this.reactTable) {
                this.reactTable.fireFetchData();
            }
        });
    }

    // handleArchive = (row) => {
    //     axios.post(`api/field/archive_by_id`, {id: row.id})
    //         .then(res => {
    //             this.getData('field/read_parts', this.state);
    //             this.setState({ delete: false, selection: [] });
    //         })
    //         .catch(err => {
    //             this.setState({ delete: false });
    //             console.log('Error: ', err);
    //         })
    // };

    deleteItem = () => {

        axios.post(`api/field/delete_part`, { selection: this.state.selection })
            .then(res => {
                this.getData('field/read_parts', this.state);
                this.setState({ delete: false, selection: [] });
            })
            .catch(err => {
                this.setState({ delete: false });
                console.log('Error: ', err);
            })
    }

    handleCloseAlert = () => {
        this.setState({ alert: !this.state.alert });
    }

    archivePart = () => {
        console.log('props za arhiviranje')
    }

    handleOpenAlert = (row) => {
        console.log('row', row)
        this.setState({ alert: true, row: row })
    }


    isSelected = key => { return this.state.selection.includes(key); };
    onSearchClick = () => this.setState({ showFilters: !this.state.showFilters });
    onEditClick() { this.setState({ add: !this.state.add, edit: true }); }
    onTableClick = () => this.props.history.push('/partsofthefield');
    onDeleteClick = () => { this.setState({ delete: !this.state.delete }); }

    render() {
        const columns = [
            { Header: i18n.t('Title'), accessor: 'naziv', headerStyle: commonHeaderStyle },
            { Header: i18n.t('Land area') + ' (ha)', accessor: 'povrsina', headerStyle: commonHeaderStyle },
            { Header: i18n.t('Number of seedlings'), accessor: 'broj_cokota', headerStyle: commonHeaderStyle },
            { Header: i18n.t('Crop'), accessor: 'kultura_naziv', headerStyle: commonHeaderStyle },
            { Header: i18n.t('Sort/Hybrid'), accessor: 'kultura_sorta', headerStyle: commonHeaderStyle },
            { Header: i18n.t('Crop subgroup'), accessor: 'kultura_podgrupa', headerStyle: commonHeaderStyle },
            { Header: i18n.t('Crop group'), accessor: 'kultura_grupa', headerStyle: commonHeaderStyle },
            // { Header: i18n.t('Local goverment'), accessor: 'katastarska_opstina',  width: 100},
            { Header: i18n.t('Type of production'), accessor: 'vrsta_proizvodnje', headerStyle: commonHeaderStyle },
            { Header: i18n.t('Date created'), accessor: 'vreme_kreiranja', Cell: ({ value }) => moment(value).format('DD.MM.YYYY.'), headerStyle: commonHeaderStyle },
            { Header: i18n.t('Date archived'), accessor: 'arhiviranje_datum', Cell: ({ value }) => moment(value).format('DD.MM.YYYY.'), headerStyle: commonHeaderStyle },

        ];
        const url = 'field/read_archive';

        const { toggleSelection, toggleAll, isSelected } = this;
        const { selectAll } = this.state;
        const checkboxProps = {
            selectAll, isSelected, toggleSelection, toggleAll, selectType: "checkbox",
            getTrProps: (state, rowInfo, instance) => {
                if (rowInfo) {
                    const selected = this.isSelected(rowInfo.original.id);
                    return { style: { backgroundColor: selected ? "#acdaf1" : "inherit", alignItems: 'flex-end' } };
                }
                return {};
            },
            getTheadFilterProps: () => { return { style: { backgroundColor: '#58B4E5' } }; },
            getTheadTrProps: () => { return { style: { backgroundColor: '#04764e', color: '#FFFFFF' } }; },
        };

        return (

            <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
            <div style={searchWrapStyle}>
                <SearchBar
                    style={searchBarStyle}
                    placeholder={i18n.t('Search by name')}
                    cancelOnEscape={true}
                    value={this.state.searchBarValue}
                    onChange={(searchValue) => this.handleSearchBar(searchValue)}
                    onCancelSearch={() => this.handleSearchBar('')}
                />
            </div>

                <div style={{ border: '1px solid #cecece', backgroundColor: '#fff', margin: '30px 30px 30px 30px', borderRadius: '3px', boxSizing: 'border-box', overflow: 'hidden', boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.5)', display: 'flex', flexDirection: 'column' }}>
                    <ReactTable ref={r => (this.reactTable = r)}
                        manual
                        data={this.state.data}
                        paging={true}
                        columns={columns}
                        keyField={'id'}
                        pageRangeDisplayed={false}
                        defaultPageSize={this.state.pageSize}
                        pageSizeOptions={[10, 25, 50, 100]}
                        pages={this.state.totalPages}
                        showPaginationBottom={true}
                        onFetchData={(state, instance) => {
                            if (this.state.loading === false) { this.getData(url, state, instance); }
                        }}
                        loading={this.state.loading}
                        className="-striped -highlight"
                        previousText={'<'}
                        nextText={'>'}
                        pageText={''}
                        loadingText={i18n.t('Loading...')}
                        noDataText={i18n.t('No rows found')}
                        ofText={i18n.t('of')}
                        showPageSizeOptions={false}
                        showPagination={true}
                        rowsText={''}
                        {...checkboxProps}
                        //{...filterOptions}
                        PreviousComponent={(props) => (
                            <button {...props} className='-btn' style={{
                                backgroundColor: '#4FA2CD',
                                color: '#FFFFFF'
                            }}>{props.children}</button>
                        )}
                        NextComponent={(props) => (
                            <button {...props} className='-btn' style={{
                                backgroundColor: '#4FA2CD',
                                color: '#FFFFFF'
                            }}>{props.children}</button>
                        )}
                        getTrProps={() => {
                            return {
                                style: {
                                    textAlign: 'center',
                                    paddingLeft: '10px',
                                    height: '50px',
                                    alignItems: 'center',
                                    overflowY: 'hidden',
                                    overflowX: 'hidden',
                                }
                            };
                        }}

                        onPageChange={() => {
                            this.state.load = true;
                        }}

                        NoDataComponent={() => (
                            <div style={{
                                textAlign: 'center', padding: '20px', display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                marginTop: -300
                            }}>
                                {!this.state.load && <span>{i18n.t('No rows found')}</span>}
                            </div>
                        )}
                    />
                </div>
            </div>
        );
    }
}

// function FilterSelect(props) {
//     return <Select
//         isMulti
//         name="naziv"
//         onChange={value => { props.onChange(value) }}
//         closeMenuOnSelect={false}
//         options={props.type}
//         className="multi-select-in-filter"
//         classNamePrefix="select"
//         placeholder={i18n.t('Select')}
//     />
// }